import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'

export default Loadable(() => import('./Components'))
